// Maintenance Management Permissions

// Maintenance Requests
export const MAINTENANCE_REQUESTS_INDEX = 159;
export const MAINTENANCE_REQUESTS_CREATE = 160;
export const MAINTENANCE_REQUESTS_UPDATE = 161;
export const MAINTENANCE_REQUESTS_DELETE = 162;
export const MAINTENANCE_REQUESTS_RESTORE = 1404;

// Work Orders
export const WORK_ORDERS_INDEX = 163;
export const WORK_ORDERS_CREATE = 164;
export const WORK_ORDERS_UPDATE = 165;
export const WORK_ORDERS_DELETE = 166;
export const WORK_ORDERS_VIEW = WORK_ORDERS_INDEX;
export const WORK_ORDERS_RESTORE = 1405;

// Maintenance Categories (Sections)
export const MAINTENANCE_CATEGORIES_INDEX = 171;
export const MAINTENANCE_CATEGORIES_CREATE = 172;
export const MAINTENANCE_CATEGORIES_UPDATE = 173;
export const MAINTENANCE_CATEGORIES_DELETE = 174;
export const MAINTENANCE_CATEGORIES_SHOW = MAINTENANCE_CATEGORIES_INDEX;
export const MAINTENANCE_CATEGORIES_RESTORE = 1403;

// Spare Parts Requests
export const SPARE_PARTS_REQUESTS_INDEX = 178;
export const SPARE_PARTS_REQUESTS_CREATE = 179;
export const SPARE_PARTS_REQUESTS_SHOW = SPARE_PARTS_REQUESTS_INDEX;
export const SPARE_PARTS_REQUESTS_UPDATE = 181;
export const SPARE_PARTS_REQUESTS_DELETE = 182;
export const SPARE_PARTS_REQUESTS_RESTORE = 1407;

// Preset Reads (Inputs Readings)
export const PRESET_READS_INDEX = 183;
export const PRESET_READS_CREATE = 184;
export const PRESET_READS_SHOW = PRESET_READS_INDEX;
export const PRESET_READS_UPDATE = 186;
export const PRESET_READS_DELETE = 187;
export const PRESET_READS_RESTORE = 1408;

// Preset Remarks (Reviews)
export const PRESET_REMARKS_INDEX = 189;
export const PRESET_REMARKS_CREATE = 190;
export const PRESET_REMARKS_SHOW = PRESET_REMARKS_INDEX;
export const PRESET_REMARKS_UPDATE = 192;
export const PRESET_REMARKS_DELETE = 193;
export const PRESET_REMARKS_RESTORE = 1409;

// Legacy aliases for backward compatibility
export const MAINTENANCE_SECTIONS_INDEX = 171;
export const MAINTENANCE_SECTIONS_CREATE = 172;
export const MAINTENANCE_SECTIONS_UPDATE = 173;
export const MAINTENANCE_SECTIONS_DELETE = 174;
export const MAINTENANCE_SECTIONS_RESTORE = 1403;
export const MAINTENANCE_REVIEWS_INDEX = 189;
export const MAINTENANCE_REVIEWS_RESTORE = 1409;
export const MAINTENANCE_INPUTS_READINGS_INDEX = 183;
export const MAINTENANCE_INPUTS_READINGS_CREATE = 184;
export const MAINTENANCE_INPUTS_READINGS_UPDATE = 186;
export const MAINTENANCE_INPUTS_READINGS_DELETE = 187;
export const MAINTENANCE_INPUTS_READINGS_RESTORE = 1408;

export const MAINTENANCE_REPORTS_INDEX = 323;

export const MAINTENANCE_MANAGE_SETTINGS = 1670;
